import { PortableText } from '@portabletext/react';
import React from 'react';
import { RequirementsProps } from '../../tools/context';

interface BlockProps {
  requirements: RequirementsProps;
}

export default function Block({ requirements, ...rest }: BlockProps) {
  const components = {
    marks: {
      internalLink: ({ value, children }) => {
        const { reference, openInNewTab } = value;
        const href = reference?.slug
          ? reference.slug.startsWith('/')
            ? reference.slug
            : `/${reference.slug}`
          : reference?.path
            ? reference.path.startsWith('/')
              ? reference.path
              : `/${reference.path}`
            : '#';

        return openInNewTab ? (
          <a href={href} target="_blank" rel="noopener noreferrer">
            {children}
          </a>
        ) : (
          <a href={href}>{children}</a>
        );
      },
      link: ({ value, children }) => {
        const { href, openInNewTab } = value;

        return openInNewTab ? (
          <a href={href} target="_blank" rel="noopener noreferrer">
            {children}
          </a>
        ) : (
          <a href={href}>{children}</a>
        );
      },
    },
  };

  return (
    <div className="Block">
      <PortableText value={rest as any} components={components as any} />
    </div>
  );
}
